import { CSSProperties } from 'react';
import { IconType } from '.';

interface RightArrowProps extends IconType {
  style?: CSSProperties;
}

export default function RightArrow({ color = '#000', className, height = 11.148, style, width = 13 }: RightArrowProps) {
  return (
    <svg width={width} height={height} style={style} className={className} viewBox="0 0 13 11.148">
      <path
        fill={color}
        id="arrow-right-solid-3"
        d="M12.728,70.155a.93.93,0,0,0,0-1.315L8.085,64.2A.93.93,0,0,0,6.77,65.512L9.832,68.57H.929a.929.929,0,0,0,0,1.857h8.9L6.773,73.486A.93.93,0,0,0,8.088,74.8l4.643-4.643Z"
        transform="translate(0 -63.925)"
      />
    </svg>
  );
}
